import { Progress } from 'antd';
import React, { useMemo } from 'react';
import { COLORS_CUR } from '../../../../../utils';
import { formatNumber } from '../../../../utils/validation';

type Props = {
    title: string;
    data: any[];
    isPdf: boolean | undefined;
};

// const CustomYAxisTick = (props: any) => {
//     const { x, y, payload } = props || {};
//     return (
//         <foreignObject x={x - 42} y={y - 15} width={60} height={30}>
//             <div className="flex w-full gap-1 items-center">
//                 <div
//                     style={{
//                         backgroundImage: `url(${require(`../../../../../assets/images/flags/${payload.value.toLowerCase()}.svg`)})`,
//                         backgroundSize: 'cover',
//                         backgroundRepeat: 'no-repeat',
//                     }}
//                     className="w-4 h-3 shadow-md"
//                 />
//                 <span className="text-xs font-[WorkSans] text-[#6D707B]">{payload.value}</span>
//             </div>
//         </foreignObject>
//     );
// };

// const CustomTooltip = ({ active, payload, label }: TooltipProps<ValueType, NameType>) => {
//     if (active) {
//         return (
//             <div className="shadow rounded bg-white px-4 py-2">
//                 <p className="label font-semibold text-xs">{label}</p>
//                 {payload && payload[0] && (
//                     <div className="desc">{formatNumber(parseFloat(String(payload[0].value || 0)))}</div>
//                 )}
//             </div>
//         );
//     }
//     return null;
// };

const CurrencyBar: React.FC<Props> = ({ title, data }) => {
    const maxData = useMemo(() => {
        return (data.length && data.reduce((value, item) => value + item.value, 0)) || 0;
    }, [data]);
    return (
        <div className="p-4 bg-white w-full">
            <p className="WorkSans-Semibold font-semibold text-sm text-[#152C52] text-left">{title}</p>
            {/* <ResponsiveContainer width="100%" height={250}>
                <BarChart data={data} layout="vertical">
                    <YAxis
                        axisLine={false}
                        strokeWidth={0.5}
                        stroke="#ACACAC"
                        dataKey={'name'}
                        tick={<CustomYAxisTick />}
                        type="category"
                        tickLine={false}
                    />
                    <Tooltip content={<CustomTooltip />} cursor={{ fill: '#f3f3f3' }} />
                    <Bar dataKey={'value'} minPointSize={2} barSize={20}>
                        <LabelList
                            dataKey={'value'}
                            position={'right'}
                            content={(props: LabelProps) => {
                                const { x, y, width, value } = props;
                                return (
                                    <text
                                        x={x + width + 5}
                                        y={y + 10}
                                        fill={'#000000'}
                                        textAnchor="middle"
                                        dominantBaseline="middle"
                                        fontSize={12}
                                        className="font-[WorkSans-Semibold] text-[#000]"
                                    >
                                        {formatNumber(parseFloat(String(value)))}
                                    </text>
                                );
                            }}
                        />
                        {data.map((d, index) => (
                            <Cell key={d['name']} fill={COLORS_CUR[index % COLORS_CUR.length]} />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer> */}
            <div className=" h-[242px] mt-2 overflow-y-auto flex flex-col gap-2 justify-evenly">
                {data?.map((payload: any, index) => {
                    const value: number = parseFloat(payload.value || '0') || 0;
                    const max: number = parseFloat(maxData || '0') || 0;
                    const percentage: number = parseFloat(((value * 100) / max).toFixed(4)) || 0;
                    return (
                        <>
                            <div>
                                <div className="flex justify-between w-full items-center">
                                    <div className="flex w-full gap-1 items-center">
                                        <div
                                            style={{
                                                backgroundImage: `url(${require(`../../../../../assets/images/flags/${payload.name.toLowerCase()}.svg`)})`,
                                                backgroundSize: 'cover',
                                                backgroundRepeat: 'no-repeat',
                                            }}
                                            className="w-4 h-3 shadow-md"
                                        />
                                        <span className="text-xs font-[WorkSans] text-[#6D707B]">{payload.name}</span>
                                    </div>
                                    <span className="text-sm text-[#000000] WorkSans-Semibold">
                                        {' '}
                                        {formatNumber(parseFloat(String(payload.value)))}
                                    </span>
                                </div>
                                <Progress
                                    strokeLinecap="square"
                                    strokeColor={COLORS_CUR[index % COLORS_CUR.length]}
                                    trailColor="#E8EAED"
                                    showInfo={false}
                                    percent={percentage}
                                />
                            </div>
                        </>
                    );
                })}
            </div>
        </div>
    );
};

export default CurrencyBar;
